export default __webpack_public_path__ + "static/media/uploadfile.926a7510.png";